import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

export const DependentNotice = () => (
  <BodyText inline size="medium" color="muted">
    {HtmlParser(I18n.t('publisher.event_types.members.calendar_dependent_location_notice'))}
  </BodyText>
)
